import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../api/api";
import { point_url } from "../../api/urls";
import { setPointBalance, setTransactions } from "../../Redux/Point";
import Loading from "../../components/Loading";
import { CoinsIcon } from "lucide-react";

const PentagonPoints = () => {
  const dispatch = useDispatch();
  const balance = useSelector((state) => state.point.points);
  const transactions = useSelector((state) => state.point.transactions);
  const [showAll, setShowAll] = useState(false);
  const [loading, setLoading] = useState(true);
  // const [conversionRate, setConversionRate] = useState(100);

  useEffect(() => {
    api
      .get(point_url)
      .then((response) => {
        const rawBalance = response.data.wallet_coin;
        const rawTransactions = response.data.wallet_log;
        // const conversion = response.data.point_to_cash_coversion;

        // setConversionRate(conversion);
        dispatch(setPointBalance(rawBalance));

        dispatch(setTransactions(rawTransactions));
      })
      .catch((error) => {
        console.error("Error fetching point data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dispatch]);

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        fontFamily: "Inter, sans-serif",
        py: 4,
        px: { xs: 2, sm: 3 },
        maxWidth: "1400px",
        mx: "auto",
        borderRadius: 2,
        backgroundColor: "#fff",
      }}
    >
      <Typography
        variant="h4"
        sx={{ mb: 3, fontSize: "24px", textAlign: "left" }}
      >
        Pentagon Points
      </Typography>

      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "300px",
          }}
        >
          <Loading />
        </Box>
      ) : (
        <>
          <Paper
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: 2,
              borderRadius: 2,
              border: "1px solid #dcdcdc",
              boxShadow: "none",
            }}
          >
            <Typography sx={{ fontSize: "18px", fontWeight: 500 }}>
              Total Points
            </Typography>
            <p className="flex gap-2 font-semibold">
              <CoinsIcon /> {balance} Points
            </p>
          </Paper>

          <Box mt={4}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Typography variant="h6">Recent Activity</Typography>
              <Button
                variant="text"
                onClick={() => setShowAll(!showAll)}
                sx={{
                  fontSize: "14px",
                  textTransform: "none",
                  color: "#1976d2",
                  fontWeight: 500,
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              ></Button>
            </Box>

            {transactions
              // .slice(0, showAll ? transactions.length : 2)
              .map((txn, index) => (
                <Box
                  key={index}
                  sx={{
                    p: 2,
                    mb: 2,
                    boxShadow: "none",
                    border: "none",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    {/* LEFT SIDE */}
                    <Box>
                      <Typography sx={{ fontWeight: 500 }}>
                        {txn.text_to_display}
                      </Typography>

                      {/* {txn.description === "Earned on Refferal:" && (
                        <Typography fontSize={13} color="text.secondary">
                          Date:
                        </Typography>
                      )} */}
                      {/* Show Date under description ONLY for Play & Earn */}
                      {txn.text_to_display === "Play & Earn" && (
                        <Typography
                          sx={{ fontSize: 13, color: "#555", mt: 0.5 }}
                        >
                          {txn.date}
                        </Typography>
                      )}

                      {txn.order_id && (
                        <p
                          className="text-sm text-gray-700"
                        >
                          Order ID: {txn.order_id}
                        </p>
                      )}
                    </Box>

                    <Box sx={{ textAlign: "right" }}>
                      <Typography
                        sx={{
                          fontWeight: 600,
                          color: txn.transaction_type.includes("CR")
                            ? "#2e7d32"
                            : "#c62828",
                          fontSize: "16px",
                        }}
                      >
                        {txn.transaction_type.includes("CR") ? "+" : "-"}{" "}
                        {txn.amount} Points
                      </Typography>

                      {/*  Referral =  i am showing  just date, else expiry */}
                      {txn.text_to_display === "Earned on Refferal:" ? (
                        <Typography fontSize={13}>{txn.date}</Typography>
                      ) : (
                        <Typography fontSize={13}>
                          Expiry: {txn.expiry_date}
                        </Typography>
                      )}

                      <Typography fontSize={13}>
                        Balance: {txn.balance}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ))}
          </Box>
        </>
      )}
    </Box>
  );
};

export default PentagonPoints;
